
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#024150","width":"100pt","height":"100pt","viewBox":"0 0 100 100","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M50 100A50 50 0 100 50a50.072 50.072 0 0014.66 35.34A50.068 50.068 0 0050 100zm0-91.406A41.409 41.409 0 0191.406 50 41.409 41.409 0 0150 91.406 41.409 41.409 0 018.594 50a41.462 41.462 0 0112.141-29.266A41.464 41.464 0 0150.001 8.593z"}}),_c('path',{attrs:{"d":"M28.453 73.109a1.567 1.567 0 001.11-2.672 28.926 28.926 0 010-40.876c.609-.61.609-1.601 0-2.21a1.565 1.565 0 00-2.212 0c-6 6.011-9.37 14.155-9.37 22.647s3.37 16.637 9.37 22.648c.293.293.688.461 1.102.461zM70.438 72.648a1.559 1.559 0 002.211 0c6-6.012 9.371-14.156 9.371-22.648S78.65 33.363 72.65 27.352a1.565 1.565 0 00-2.21 0c-.61.61-.61 1.602 0 2.21a28.926 28.926 0 010 40.877c-.61.61-.61 1.602 0 2.21zM49.945 75.781H50c3.453 0 6.25-2.797 6.25-6.25s-2.797-6.25-6.25-6.25a6.25 6.25 0 00-.055 12.5zM47.789 60.156h4.422a3.118 3.118 0 003.125-3.031l.914-29.688a3.135 3.135 0 00-3.125-3.219h-6.25a3.137 3.137 0 00-3.125 3.219l.914 29.688a3.126 3.126 0 003.125 3.031z"}})])
          )
        }
      }
    